import { RefObject } from 'react';

export const isInViewport = (ref: RefObject<HTMLElement | null>, offset = 0) => {
  if (!ref.current) return false;
  const top = ref.current.getBoundingClientRect().top;
  return top + offset >= 0 && top - offset <= window.innerHeight;
};
